<template>
  <div class="btn-group" ref="statusFilter">
    <div @click="toggleMenu()" class="dropdown-toggle" v-if="selectedOption.label">
      <span class="selected-name">
        {{ selectedOption.label }}
      </span>
       <svgicon name="arrow-down"
        class="dropdown-icon" width="11.23" height="18" :original="true" />
    </div>
    <ul class="dropdown-menu" v-if="showMenu">
      <li v-for="option in options" v-bind:key="option.id" @click="updateOption(option)">
        <a href="javascript:void(0)">
          {{ option.label }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedOption: {
        name: null,
      },
      showMenu: false,
    };
  },
  props: {
    options: {
      type: [Array, Object],
    },
    selected: {},
  },

  mounted() {
    this.selectedOption = this.selected;
  },

  created() {
    document.addEventListener('click', this.documentClick);
  },

  destroyed() {
    document.removeEventListener('click', this.documentClick);
  },

  methods: {
    updateOption(option) {
      this.selectedOption = option;
      this.showMenu = false;
      this.$emit('updateOption', this.selectedOption);
    },

    toggleMenu() {
      this.showMenu = !this.showMenu;
    },

    getStatus(id) {
      return `status-${id}`;
    },

    documentClick(event) {
      const el = this.$refs.statusFilter;
      const target = event.target;
      if ((el !== target) && !el.contains(target)) {
        this.showMenu = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@common/styles-transporter/settings";

  .btn-group {
    min-width: 50px;
    position: relative;
    margin: 5px 1px;
    display: inline-block;
    vertical-align: middle;

    .selected-name {
      display: inline-block;
      width: 150px;
      color: rgb(79, 80, 80);
      font-size: 1.4rem;
    }

    .status-dropdown {
      width: 12px;
      height: 12px;
      display: inline-block;
      position: relative;
      top: 1px;
      margin-right: 4px;
      &.status-0 {
        background: #fff;
      }
      &.status-0 {
        background: $intented;
      }
      &.status-4 {
        background: $assigned;
      }
      &.status-5 {
        background: $arrived;
      }
      &.status-6 {
        background: $dispatched;
      }
      &.status-7 {
        background: $delivered;
      }
      &.status-8 {
        background: $canceled;
      }
    }
  }

  .dropdown-toggle {
    min-width: 50px;
    cursor: pointer;
  }

  .dropdown-menu {
    position: absolute;
    z-index: 5;
    padding: 10px 0;
    top: 100%;
    left: 0;
    min-width: 50px;
    margin-top: 12px;
    list-style: none;
    font-size: 1rem;
    text-align: left;
    background-color: #fff;
    top: 25px;
    left: -15px;
    border: 1px solid #CBD4D8;
    width: 219px;
  }

  .dropdown-menu > li > a {
      padding: 10px 28px;
      display: block;
      clear: both;
      font-weight: normal;
      color: #646464;
      white-space: nowrap;
      text-decoration: none;
      font-size: 1.4rem;
  }

  .dropdown-menu > li {
    font-size: 1.4rem;
    overflow: hidden;
    width: 100%;
    position: relative;
    margin: 0;
    padding: 0;
    min-width: 175px;
  }
</style>
